/* BLACKWALL B2B-Client — Gating + Live-JTL-Preise über das EIGENE Portal (nicht Shopify-Konten).
   Session-Token in localStorage bw_sess. Spricht App-Proxy-unabhängig direkt mit hub-api.
   Setzt <html class="bw-b2b-approved|bw-b2b-pending|bw-b2b-guest"> und füllt [data-artnr] Preise.
   window.bwB2B API: {approved,pending,loggedIn,tier, priceOf(sku), onReady(cb), fmt(eur)} */
(function () {
  var PROXY = 'https://hub.webagentur-twopixels.de/proxy/blackwall';
  var TOK = 'bwsf_e4ca4919520277ed1474414861872d6f468e8fda';
  function sess() { try { return localStorage.getItem('bw_sess') || ''; } catch (e) { return ''; } }
  function setSess(t) { try { t ? localStorage.setItem('bw_sess', t) : localStorage.removeItem('bw_sess'); } catch (e) {} }
  function fmt(eur) { return (Number(eur) || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }

  var B2B = window.bwB2B = {
    approved: false, pending: false, loggedIn: false, tier: '', prices: {}, ready: false, _cbs: [],
    fmt: fmt,
    priceOf: function (sku) { return this.prices[String(sku || '').trim()] || null; },
    onReady: function (cb) { if (this.ready) { try { cb(this); } catch (e) {} } else { this._cbs.push(cb); } }
  };

  function fire() {
    B2B.ready = true;
    var h = document.documentElement;
    h.classList.toggle('bw-b2b-approved', B2B.approved);
    h.classList.toggle('bw-b2b-pending', B2B.pending && !B2B.approved);
    h.classList.toggle('bw-b2b-guest', !B2B.loggedIn);
    fillCards();
    B2B._cbs.forEach(function (cb) { try { cb(B2B); } catch (e) {} });
    B2B._cbs = [];
    try { document.dispatchEvent(new CustomEvent('bw:b2b', { detail: B2B })); } catch (e) {}
  }

  function collectSkus() {
    var set = {};
    document.querySelectorAll('[data-artnr]').forEach(function (e) {
      String(e.getAttribute('data-artnr') || '').split(',').forEach(function (a) { a = a.trim(); if (a) set[a] = 1; });
    });
    // Matrix-Zeilen existieren beim ersten Lauf evtl. noch nicht -> SKUs direkt aus dem Varianten-JSON ziehen
    document.querySelectorAll('[data-variants]').forEach(function (el) {
      try { JSON.parse(el.getAttribute('data-variants') || '[]').forEach(function (v) { if (v && v.sku) set[String(v.sku).trim()] = 1; }); } catch (e) {}
    });
    return Object.keys(set);
  }

  // Netto-Preise in die Produktkarten schreiben (ersetzt „Preis nach Login")
  // Preis-Quelle: JTL /preise (autoritativ, EUR) sonst Shopify-Nettopreis (data-price in Cent).
  function fillCards() {
    document.querySelectorAll('.pcard[data-artnr]').forEach(function (card) {
      var sku = (card.getAttribute('data-artnr') || '').split(',')[0].trim();
      var body = card.querySelector('.body'); if (!body) return;
      var row = body.querySelector('.price-row');
      var hint = body.querySelector('.login-hint');
      if (!B2B.approved) { if (hint) hint.textContent = B2B.pending ? 'Freigabe ausstehend' : 'Händlerpreis nach Login'; return; }
      var p = B2B.priceOf(sku);
      var centsAttr = card.getAttribute('data-price');
      var net = (p && p.net != null) ? p.net : (centsAttr != null && centsAttr !== '' ? (parseInt(centsAttr, 10) / 100) : null);
      if (net == null || !row) return;
      row.innerHTML = '<span class="price">' + fmt(net) + ' <span class="net">netto</span></span>';
      if (p && p.staffel && p.staffel.length && !row.parentNode.querySelector('.staffel-hint')) {
        var d = document.createElement('span'); d.className = 'staffel-hint';
        d.innerHTML = '↓ ab ' + p.staffel[0].ab + ' Stk. ' + fmt(p.staffel[0].net);
        row.insertAdjacentElement('afterend', d);
      }
    });
  }

  function loadPrices(cb) {
    var skus = collectSkus();
    if (!skus.length) return cb();
    fetch(PROXY + '/preise?sess=' + encodeURIComponent(sess()), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'x-bw-token': TOK },
      body: JSON.stringify({ artnrs: skus })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.approved && j.prices) { B2B.prices = j.prices; if (j.tier) B2B.tier = j.tier; }
      cb();
    }).catch(function () { cb(); });
  }

  function boot() {
    if (!sess()) { B2B.loggedIn = false; return fire(); }
    fetch(PROXY + '/profil.json?sess=' + encodeURIComponent(sess()), { headers: { 'x-bw-token': TOK } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p && p.ok) {
          B2B.loggedIn = true; B2B.approved = !!p.approved; B2B.pending = !p.approved; B2B.tier = p.tier || '';
          if (p.sess) setSess(p.sess);
          if (B2B.approved) return loadPrices(fire);
        } else { setSess(''); }
        fire();
      })
      .catch(function () { fire(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
